/* MLMT 2027 — the page chrome controllers: megamenu hydrator, announcement
   bar (an emptied bar leaves no landmark; rotation only from two messages),
   mobile bubbles, card swatch lock (a preview until 18 Sep 2026). The header value bar's carousel lived here
   until 19 Sep 2026 — the bar is static now and needs no script. One cached
   file, loaded deferred once from layout/theme.liquid after theme.js.

   12 Sep 2026 — every block in here used to be an inline <script> inside its
   section or snippet, none of them holding Liquid, all of them byte-identical
   on every served page. Each is an IIFE that finds its own element and returns
   when it is absent, so the file is safe on any template. Deferred means they
   run after the document is parsed, which for every one of them is the same
   or a better moment than parse time. */

/* ══ sections/mlmt-megamenu.liquid — panel hydrator: each panel ships inside <template data-mm-tpl>; the first hover/focus/touch clones it in, an idle pass after load does the rest ══ */
(function () {
  var root = document.querySelector('.mm__row');
  if (!root) return;
  function hydrate(item) {
    var t = item && item.querySelector('template[data-mm-tpl]');
    if (!t) return;
    t.parentNode.appendChild(t.content.cloneNode(true));
    t.parentNode.removeChild(t);
  }
  function onEnter(e) { hydrate(e.target.closest && e.target.closest('.mm__item')); }
  root.addEventListener('mouseover', onEnter);
  root.addEventListener('focusin', onEnter);
  root.addEventListener('touchstart', onEnter, { passive: true });
  var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 2500); };
  window.addEventListener('load', function () {
    idle(function () { root.querySelectorAll('.mm__item').forEach(hydrate); });
  });
})();

/* ══ sections/mlmt-announcement.liquid — an emptied bar leaves no landmark behind ══ */
/* 19 Sep 2026 — the top bar's sale line is cleared in sections/header-group.json,
   so the section renders <div id="mlmt-ann" role="region" aria-label="Announcements">
   around an empty .mlmt-ann__track. assets/mlmt-chrome.css takes the region out
   with `.mlmt-ann:has(> .mlmt-ann__track:empty)`, but where :has() is not
   supported (iOS Safari before 15.4, Firefox before 121, older Samsung
   Internet — phones a 50+ shopper may well still carry) only the track is
   hidden, and VoiceOver / TalkBack land on an empty "Announcements, region" at
   the top of every page (review, 19 Sep 2026). This is the same test done
   here: an empty track — no elements, no text, whitespace included, which is
   wider than :empty — hides the region; a bar with a line is left alone.
   display:none takes it out of the accessibility tree, not just off screen.
   Re-armed on the editor's section re-render, which never re-runs a script. */
(function(){
  function settle(){
    var ann = document.getElementById('mlmt-ann');
    if (!ann) return;
    var track = ann.querySelector('.mlmt-ann__track');
    var empty = !!track && track.children.length === 0 && !(track.textContent || '').trim();
    ann.style.display = empty ? 'none' : '';
  }
  settle();
  document.addEventListener('shopify:section:load', settle);
})();

/* ══ sections/mlmt-announcement.liquid — rotating messages (only when the bar is not in offer mode) ══ */
(function(){
  var msgs = document.querySelectorAll('#mlmt-ann [data-ann-msg]');
  if (msgs.length < 2) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var i = 0, timer = null, HOLD = 5000;
  function show(n){
    msgs[i].classList.remove('is-on');
    i = (n + msgs.length) % msgs.length;
    msgs[i].classList.add('is-on');
  }
  function start(){ stop(); timer = setInterval(function(){ show(i + 1); }, HOLD); }
  function stop(){ if (timer) { clearInterval(timer); timer = null; } }

  /* a background tab would otherwise burn through the rotation and come back
     on an arbitrary line */
  document.addEventListener('visibilitychange', function(){
    if (document.hidden) stop(); else start();
  });
  start();
})();

/* ══ sections/mlmt-bubble-nav.liquid — open the rail on the category you are in ══ */
(function(){
  var rail = document.querySelector('[data-bn-rail]');
  if (!rail) return;
  /* Open on the category you are in. scrollIntoView would also scroll the
     PAGE to the rail on load, which hijacks the visitor — so the offset is
     computed and applied to the rail alone. */
  var here = rail.querySelector('.is-here');
  if (!here) return;
  var cell = here.parentNode;
  var want = cell.offsetLeft - (rail.clientWidth / 2) + (cell.offsetWidth / 2);
  if (want > 4) rail.scrollLeft = want;
})();

/* ══ sections/mlmt-card-chrome.liquid — card swatch LOCK (hover, focus or tap a stone swatch: image, title, price, label, links and quick-add follow it — and stay) ══ */
(function(){
  if (window.__mlmtCardStones) return;
  window.__mlmtCardStones = true;

  /* 18 Sep 2026 — the preview became a LOCK. Jordan: "i want to make sure
     that if you hover over the variant that it 'locks' it. So if we scroll
     over gold or click gold that it just locks in the collection page, and
     that add to cart button is connected to that variant. If we click on the
     variant it doesnt go to the product page, it just switches card in the
     collection page."

     Until today this block was a preview: hover a swatch and the card showed
     the sibling; mouseout put everything back; touch devices got nothing
     ("the swatch is just a link"); a click followed the href to the PDP.
     Three things changed, everything else is the same code:

       · mouseout / focusout are gone. There is no restore-on-leave — the
         swatch you last touched IS the card until you touch another one.
         Moving along the row switches; leaving the card keeps the last one.
       · a plain left click on a swatch is intercepted (preventDefault) and
         locks it instead of navigating. The href stays on the anchor for
         no-JS, right-click, ctrl/cmd-click and middle-click (auxclick is not
         'click', so it never reaches this handler) — only the default click
         is taken. This is also how a phone switches the card at all: the
         (hover:hover) gate that used to return from the whole block is now
         on the mouseover path only, so a tap goes straight to the click lock
         and never trips Safari's "first tap is a hover" rule.
       · the locked swatch is marked: aria-pressed="true" on it (the previous
         one flips to "false") and the is-here ring the row already draws on
         the card's own stone moves with it, so the ring always means "the
         one you are looking at". The server marks the starting one (see
         snippets/mlmt-card-stones).

     The locked state is the card's truth. Image, title, price (was-price and
     now-price on the peek line, rendered server-side per swatch), the
     stone/metal label under the price, every product link on the card, and
     the quick-add — variant id, availability, disabled state and LABEL
     ("Sold out" / "Add to cart"), plus the card's own out-of-stock veil. The
     quick-add reads data-variant-id off the button at click time (see
     assets/mlmt-quick-add.js, addToCart(button)), so what is on the button
     when you press it is what goes in the cart — never a value captured at
     page load. Sister-product swatches (other handles) carry that product's
     own selected variant, so the same button adds THAT product.

     Locking back onto the card's OWN swatch restores instead of previewing:
     the server-rendered markup is the truth for the product the card was
     built for (srcset, the ?variant= links, the Intelligems price nodes), so
     every saved value goes back verbatim rather than being re-derived.

     Everything is delegated from document and all per-card state lives on
     the card element itself, so cards that arrive later — theme.AjaxRenderer
     swapping #CollectionAjaxContent on a filter, infinite scroll appending,
     the editor's shopify:section:load re-render — need no re-init and carry
     no stale state (an element replaced is an element forgotten). The guard
     above keeps a second run of this file from binding twice.

     Motion: nothing here animates; the swap is an attribute write. The ring
     and lift transitions are CSS and already switch off under
     prefers-reduced-motion in mlmt-card-chrome.css.

     18 Sep 2026, review — three things a persistent lock made visible that a
     hover preview could hide behind its mouseout:

       · own-ness was INFERRED (swatch variant id == the quick-add's original
         id) and the two were computed by different rules on silver pages:
         the row gave every Miami swatch the Gold variant, the card had picked
         its first Silver one, so hovering the card's own ring-marked stone
         "locked" the card to gold and left it there. The server now marks
         the swatch it rendered the card for with data-cs-own
         (snippets/mlmt-card-stones) and isOwn() reads that; the id
         comparison is only the fallback for markup rendered before.
       · the collection image-nav (mlmt-collection.js) pages through the
         card's ORIGINAL product's gallery by writing inline opacity/z-index
         onto the image layers, so a lock after an arrow press swapped src on
         a primary the nav had hidden, and an arrow press after a lock showed
         the Classic's second photo under the Pink Sapphire title. A lock now
         resets those layers first (navReset) and the arrows/dots are hidden
         while a card is locked — .product-card[data-cs-preview]
         .mlmt-image-overlay in mlmt-card-chrome.css — until restore() takes
         the attribute off.
       · the heart is a <button data-mlmt-wish>, not a link, so re-pointing
         a[href] never reached it and a locked Pink Sapphire card saved the
         Classic. A sister lock now carries the heart's data-wish-* (and the
         quick-add's data-product-id, from the new data-cs-pid) to the sibling
         and repaints its saved state from window.mlmtWishlist; restore() puts
         them back. Metal locks are the same product and leave the heart alone. */

  var hoverMq = window.matchMedia ? window.matchMedia('(hover:hover)') : null;
  /* read at event time, not at init — a convertible that grows a mouse
     after load should get hover locks too */
  function canHover(){ return !!(hoverMq && hoverMq.matches); }

  function card(el){ return el && el.closest ? el.closest('.product-card') : null; }

  /* 18 Sep 2026 (review): the collection image-nav (assets/mlmt-collection.js,
     updateDisplay) shows a gallery photo by writing opacity/z-index
     !important inline onto .product-image.primary, .secondary and the
     .mlmt-enhanced-image layers it appended — and that gallery is the card's
     ORIGINAL product's, bound by handle when the card was enhanced. A lock
     that swaps src on a primary the nav has hidden shows nothing of what it
     locked, so every lock puts the layers back where the server left them
     first. primary/secondary lose the inline pair (the server wrote none);
     the appended layers go back to the hidden state they were created in —
     removing THEIR opacity would show them, nothing in a stylesheet hides
     them. The dots return to the first one and the enhancer's own index for
     this handle (read off the overlay it wrote) is reset, so the dots and
     its state agree when restore() brings the arrows back. Every read is
     guarded: a card with no nav is the common case. */
  function navReset(c){
    [].forEach.call(c.querySelectorAll('.product-image.primary, .product-image.secondary'), function(el){
      el.style.removeProperty('opacity');
      el.style.removeProperty('z-index');
    });
    [].forEach.call(c.querySelectorAll('.mlmt-enhanced-image'), function(el){
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('z-index', '1', 'important');
    });
    [].forEach.call(c.querySelectorAll('.mlmt-image-dot'), function(d, i){
      d.classList.toggle('active', i === 0);
    });
    try {
      var ov = c.querySelector('.mlmt-image-overlay');
      var h  = ov ? ov.getAttribute('data-product-handle') : null;
      var en = window.mlmtFixedEnhancer;
      if (h && en && en.imageStates && en.imageStates[h]) en.imageStates[h].currentIndex = 0;
    } catch (e) { /* the enhancer is optional; the layers are already reset */ }
  }

  /* ── the locked variant's own gallery (19 Sep 2026) ─────────────────────
     Jordan: "when it's the main variant we can press the arrows for more
     pictures, but once we go to the secondary variant it doesn't show arrows —
     fix this." The arrows were hidden under a lock because the enhancer's
     gallery is the ORIGINAL product's, bound by handle. Every metal swatch now
     carries its variant's photographs in data-cs-gal (snippets/mlmt-card-gallery:
     short form after "/files/", pipe-separated — the prefix is taken from
     data-cs-img, which is a full URL). lockGallery() hands that list to the
     enhancer's own builder (addFunctionalNavigation) under the card's handle, so
     the arrows, dots, layers and handlers are the enhancer's — nothing here
     re-implements the nav — and data-cs-gal on the card un-hides the overlay
     (assets/mlmt-card-chrome.css). unlockGallery() rebuilds the original
     product gallery from the enhancer's productData on restore(). A card the
     enhancer never touched (one photo, no nav) gets a nav for the lock and
     loses it again on restore. Every step is guarded: the enhancer is optional. */
  function galleryOf(sw){
    var raw = sw.getAttribute('data-cs-gal'), first = sw.getAttribute('data-cs-img') || '';
    if (!raw) return null;
    var k = first.indexOf('/files/');
    if (k === -1) return null;
    var prefix = first.slice(0, k + 7);
    var out = [];
    raw.split('|').forEach(function(t){ t = t.trim(); if (t) out.push(/^https?:/i.test(t) ? t : prefix + t); });
    return out.length > 1 ? out : null;
  }
  function handleOf(c){
    var a = c.querySelector('a.product-image-link[href], .product-name a[href]');
    var m = a ? /\/products\/([^\/?#]+)/.exec(a.getAttribute('href') || '') : null;
    return m ? m[1] : null;
  }
  function lockGallery(c, urls){
    var cont = c.querySelector('.product-image-container');
    var en = window.mlmtFixedEnhancer;
    if (!cont) return false;
    if (!en || typeof en.addFunctionalNavigation !== 'function' || !en.imageStates || !en.isInitialized){
      /* the enhancer loads its product list first (a fetch) — a metal-facet lock on
         page load lands before it. Try again a few times; the lock is still on. */
      var tries = (c.__csGalTries || 0) + 1;
      if (tries <= 8){
        c.__csGalTries = tries;
        setTimeout(function(){
          var sw = c.__csLocked;
          if (sw && c.hasAttribute('data-cs-preview')){ var g = galleryOf(sw); if (g) lockGallery(c, g); }
        }, 600);
      }
      return false;
    }
    c.__csGalTries = 0;
    var ov = cont.querySelector('.mlmt-image-overlay');
    var handle = (ov && ov.getAttribute('data-product-handle')) || (c.__csGal && c.__csGal.handle) || handleOf(c);
    if (!handle) return false;
    if (!c.__csGal){
      var sec0 = cont.querySelector('.product-image.secondary:not(.mlmt-enhanced-image)');
      c.__csGal = {
        handle: handle,
        hadNav: !!ov,
        total: (en.imageStates[handle] && en.imageStates[handle].totalImages) || 0,
        sec: sec0 ? { src: sec0.getAttribute('src'), srcset: sec0.getAttribute('srcset') } : null
      };
    }
    [].forEach.call(cont.querySelectorAll('.mlmt-image-overlay, .mlmt-enhanced-image, .mlmt-image-counter'), function(el){ el.remove(); });
    var sec = cont.querySelector('.product-image.secondary:not(.mlmt-enhanced-image)');
    if (sec){ sec.setAttribute('src', urls[1] || urls[0]); sec.removeAttribute('srcset'); }
    else {
      /* no hover photograph on this card: the enhancer shows index 1 from an
         appended layer when there is no .secondary, so give it one */
      var l1 = document.createElement('img');
      l1.src = urls[1]; l1.alt = ''; l1.loading = 'lazy';
      l1.className = 'product-image mlmt-enhanced-image';
      l1.setAttribute('data-image-index', '1'); l1.setAttribute('data-mlmt-fixed', 'true');
      l1.style.cssText = 'position:absolute!important;top:0!important;left:0!important;width:100%!important;height:100%!important;object-fit:cover!important;opacity:0!important;transition:opacity .3s ease!important;z-index:1!important;display:block!important;pointer-events:none!important';
      cont.appendChild(l1);
    }
    en.imageStates[handle] = { currentIndex: 0, totalImages: urls.length, isAnimating: false };
    var tn = c.querySelector('.product-name a');
    en.addFunctionalNavigation(cont, { handle: handle, title: tn ? tn.textContent : handle, images: urls });
    c.setAttribute('data-cs-gal', '');
    return true;
  }
  function unlockGallery(c){
    var g = c.__csGal;
    c.removeAttribute('data-cs-gal');
    if (!g) return;
    c.__csGal = null;
    var cont = c.querySelector('.product-image-container');
    var en = window.mlmtFixedEnhancer;
    if (!cont) return;
    [].forEach.call(cont.querySelectorAll('.mlmt-image-overlay, .mlmt-enhanced-image, .mlmt-image-counter'), function(el){ el.remove(); });
    var sec = cont.querySelector('.product-image.secondary:not(.mlmt-enhanced-image)');
    if (sec && g.sec){
      if (g.sec.src) sec.setAttribute('src', g.sec.src);
      if (g.sec.srcset) sec.setAttribute('srcset', g.sec.srcset); else sec.removeAttribute('srcset');
    }
    if (!en || !en.imageStates) return;
    var pd = en.productData && en.productData[g.handle];
    if (g.hadNav && pd && pd.images && pd.images.length > 1){
      en.imageStates[g.handle] = { currentIndex: 0, totalImages: pd.images.length, isAnimating: false };
      en.addFunctionalNavigation(cont, pd);
    } else {
      delete en.imageStates[g.handle];
    }
  }

  /* 18 Sep 2026 (review): the heart's record, read by mlmt-wishlist-core at
     click time. Saved once per lock cycle and put back verbatim on restore;
     aria-label carries the title too, so it travels with the rest. */
  var WISH_ATTRS = ['data-wish-handle', 'data-wish-title', 'data-wish-url',
                    'data-wish-img', 'data-wish-price', 'data-wish-compare', 'aria-label'];
  function paintHeart(heart){
    var on = false;
    try {
      on = !!(window.mlmtWishlist && window.mlmtWishlist.has &&
              window.mlmtWishlist.has(heart.getAttribute('data-wish-handle')));
    } catch (e) { /* storage unreadable: paint it unsaved, the core does the same */ }
    heart.classList.toggle('is-saved', on);
    heart.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function preview(sw){
    var c = card(sw);
    if (!c) return;
    var img = c.querySelector('.product-image.primary');
    if (!img) return;

    if (!c.__csSaved){
      c.__csSaved = {
        src: img.getAttribute('src'),
        srcset: img.getAttribute('srcset'),
        /* every link that leads off this card, so a click always lands on
           what is on screen rather than on the card's own product */
        title: null,
        /* 18 Sep 2026: the sold-out veil is per card, the swatch is per
           variant — remembered so the own-swatch restore can put it back */
        oos: c.classList.contains('out-of-stock'),
        /* the heart's record, filled the first time a SISTER is locked */
        wish: null,
        links: [].map.call(c.querySelectorAll('a[href]'), function(a){
          return { a: a, href: a.getAttribute('href') };
        })
      };
    }
    /* the was-price, read once — the peek line and (since 18 Sep 2026) the
       heart's record both want it, and a card without a price box still has
       a heart */
    var wasTxt = sw.getAttribute('data-cs-compare') || '';
    /* the peek line: the sibling's stone and its OWN price, rendered
       server-side. Created once per card, then reused. */
    var priceBox = c.querySelector('.product-price');
    if (priceBox){
      var peek = priceBox.querySelector('.mlmt-cs__peek');
      if (!peek){
        peek = document.createElement('span');
        peek.className = 'mlmt-cs__peek';
        priceBox.appendChild(peek);
      }
      peek.innerHTML = '';
      /* the was-price too — dropping it on hover made every card look like it
         had quietly lost its discount */
      /* 19 Sep 2026, Jordan: "on the collection page when you switch variants the letter
         size changes." The peek carried its own 20px/14px while the real line is 14px/11px
         on a phone, and it added a metal tag the real line never has. The peek's two
         numbers now wear the real line's classes — price-original / price-sale — so every
         breakpoint sizes them identically by construction; the tag is gone (the swatch
         ring already says which metal is showing). */
      if (wasTxt){
        var ps = document.createElement('s'); ps.className = 'price-original'; ps.textContent = wasTxt;
        peek.appendChild(ps);
      }
      var pb = document.createElement('b'); pb.className = 'price-sale'; pb.textContent = sw.getAttribute('data-cs-price') || '';
      peek.appendChild(pb);
    }

    /* ── the quick-add follows the lock ──────────────────────────────────
       This is what replaced dimming the button. Swapping the variant here is
       what makes the live button safe: it adds the piece on screen, not the
       card's own product. Put back verbatim only when the card's own swatch
       is locked again (restore). */
    var btn = c.querySelector('.add-to-cart-btn');
    var vid = sw.getAttribute('data-cs-vid');
    /* 12 Sep 2026: the swatch no longer carries data-cs-href (it is the
       swatch's own href) or data-cs-cardimg (the same image as data-cs-img
       at width 400 — derived here). Two attributes x 4 swatches x 40 cards
       was ~57 KB of repeated URLs per collection page. */
    var to = sw.getAttribute('data-cs-img');
    var href = sw.getAttribute('href');
    var hasAv = sw.hasAttribute('data-cs-avail');
    var av = sw.getAttribute('data-cs-avail') === 'true';
    /* the 400px card image, derived once — the button and the heart both want it */
    var si = to ? to.replace(/([?&])width=\d+/, '$1width=400') : '';
    /* a SISTER is another product: it carries the sibling's title (and, since
       18 Sep 2026, its product id). A metal swatch is the same product. */
    var st = sw.getAttribute('data-cs-title');
    var spid = sw.getAttribute('data-cs-pid');
    if (btn && vid){
      if (!c.__csBtn){
        c.__csBtn = {
          vid:   btn.getAttribute('data-variant-id'),
          pid:   btn.getAttribute('data-product-id'),
          title: btn.getAttribute('data-product-title'),
          img:   btn.getAttribute('data-product-image'),
          price: btn.getAttribute('data-product-price'),
          avail: btn.getAttribute('data-available'),
          dis:   btn.disabled,
          label: btn.textContent
        };
      }
      btn.setAttribute('data-variant-id', vid);
      /* 18 Sep 2026 (review): the product id moves with the variant id, so
         the button never says product A / variant of product B */
      if (spid) btn.setAttribute('data-product-id', spid);
      if (st) btn.setAttribute('data-product-title', st);
      if (si) btn.setAttribute('data-product-image', si);
      var sp = sw.getAttribute('data-cs-rawprice');if (sp) btn.setAttribute('data-product-price', sp);
      btn.setAttribute('data-available', av ? 'true' : 'false');
      /* a sold-out sibling really is unbuyable — that disable is the truth,
         not the preview guard we just removed */
      btn.disabled = !av;
      /* 18 Sep 2026: the label follows too — a locked sold-out variant used
         to sit under a dimmed button that still read "Add to cart". Left
         alone mid-add: addToCart() owns the text while it says Adding…/Added!
         and puts its own captured label back after 2s. */
      if (!btn.classList.contains('loading') && !btn.classList.contains('success')){
        btn.textContent = av ? 'Add to cart' : 'Sold out';
      }
    }
    /* the veil (.out-of-stock) follows the locked variant's own stock — the
       last-resort single swatch carries no availability and leaves it alone */
    if (hasAv) c.classList.toggle('out-of-stock', !av);

    /* the title follows the image. Safe only because the quick-view button is
       held off while previewing — extractProductData reads .product-name a. */
    var t = c.querySelector('.product-name a');
    if (t && sw.getAttribute('data-cs-title')){
      if (c.__csSaved.title == null) c.__csSaved.title = t.textContent;
      t.textContent = sw.getAttribute('data-cs-title');
    }

    /* 18 Sep 2026 (review): whatever the image-nav did to the layers is
       undone BEFORE the swap, or the new src lands on a hidden primary */
    navReset(c);
    if (to){
      img.setAttribute('src', to);
      /* srcset would otherwise keep serving the ORIGINAL image at most
         viewport widths — src alone is not enough to swap a responsive image */
      img.removeAttribute('srcset');
    }
    /* 19 Sep 2026: the locked variant's own photographs drive the arrows */
    var gal = galleryOf(sw);
    if (!(gal && lockGallery(c, gal))) unlockGallery(c);
    if (href){
      c.__csSaved.links.forEach(function(rec){
        if (rec.a.classList.contains('mlmt-cs__sw')) return;   /* leave the swatches */
        rec.a.setAttribute('href', href);
      });
    }

    /* ── the heart follows a SISTER lock ─────────────────────────────────
       18 Sep 2026 (review): the wishlist control is a <button data-mlmt-wish>,
       read attribute-by-attribute by mlmt-wishlist-core when it is pressed,
       so the a[href] sweep above never reached it and a card locked to Pink
       Sapphire saved the Classic. The record is rewritten from the swatch —
       handle from its href (/products/<handle>, with or without a collection
       prefix), title, url, the 400px image, the peek's price and was-price —
       and the saved state repainted for the NEW handle. Same product (a
       metal swatch) means the same record; nothing to do. */
    var heart = c.querySelector('[data-mlmt-wish]');
    if (heart && st && href){
      if (!c.__csSaved.wish){
        var saved = {};
        WISH_ATTRS.forEach(function(k){ saved[k] = heart.getAttribute(k); });
        c.__csSaved.wish = saved;
      }
      var hm = /\/products\/([^\/?#]+)/.exec(href);
      if (hm) heart.setAttribute('data-wish-handle', hm[1]);
      heart.setAttribute('data-wish-title', st);
      heart.setAttribute('data-wish-url', href);
      if (si) heart.setAttribute('data-wish-img', si);
      heart.setAttribute('data-wish-price', sw.getAttribute('data-cs-price') || '');
      if (wasTxt) heart.setAttribute('data-wish-compare', wasTxt);
      else heart.removeAttribute('data-wish-compare');
      heart.setAttribute('aria-label', 'Save ' + st + ' to your wishlist');
      paintHeart(heart);
    }
    c.setAttribute('data-cs-preview', '');
  }

  function restore(c){
    if (!c || !c.__csSaved) return;
    unlockGallery(c);
    var img = c.querySelector('.product-image.primary');
    var s = c.__csSaved;
    if (img){
      if (s.src) img.setAttribute('src', s.src); else img.removeAttribute('src');
      if (s.srcset) img.setAttribute('srcset', s.srcset); else img.removeAttribute('srcset');
    }
    s.links.forEach(function(rec){
      if (rec.href) rec.a.setAttribute('href', rec.href);
    });
    if (s.title != null){
      var t = c.querySelector('.product-name a');
      if (t) t.textContent = s.title;
    }
    c.classList.toggle('out-of-stock', !!s.oos);
    /* put the quick-add back on the card's own product */
    var btn = c.querySelector('.add-to-cart-btn');
    if (btn && c.__csBtn){
      var b = c.__csBtn;
      if (b.vid)   btn.setAttribute('data-variant-id', b.vid);
      if (b.pid)   btn.setAttribute('data-product-id', b.pid);
      if (b.title) btn.setAttribute('data-product-title', b.title);
      if (b.img)   btn.setAttribute('data-product-image', b.img);
      if (b.price) btn.setAttribute('data-product-price', b.price);
      if (b.avail) btn.setAttribute('data-available', b.avail);
      btn.disabled = !!b.dis;
      if (b.label != null && !btn.classList.contains('loading') && !btn.classList.contains('success')){
        btn.textContent = b.label;
      }
      c.__csBtn = null;
    }
    /* the heart goes back to the card's own product, verbatim */
    if (s.wish){
      var heart = c.querySelector('[data-mlmt-wish]');
      if (heart){
        WISH_ATTRS.forEach(function(k){
          if (s.wish[k] == null) heart.removeAttribute(k);
          else heart.setAttribute(k, s.wish[k]);
        });
        paintHeart(heart);
      }
    }
    c.__csSaved = null;
    c.removeAttribute('data-cs-preview');
  }

  /* Is this swatch the product/variant the card was rendered for?

     18 Sep 2026 (review): the server SAYS so now — data-cs-own on the swatch
     it rendered the card for (snippets/mlmt-card-stones). Inferring it from
     an id comparison broke on every silver collection: the row and the card
     picked their variant by different rules, the ids never matched, and the
     card's own stone locked the card to its gold sibling.

     The comparison below is the fallback for a row rendered before that
     attribute existed (the theme pushed, this script cached ahead of it, or
     the other way round): judged by variant id against the quick-add's
     ORIGINAL id (saved before any swap), which is the one value the server
     wrote for exactly that purpose. A swatch with no variant at all is the
     last-resort single stone — it is the card by definition. */
  function isOwn(c, sw){
    if (sw.hasAttribute('data-cs-own')) return true;
    var row = sw.closest ? sw.closest('.mlmt-cs') : null;
    if (row && row.querySelector('[data-cs-own]')) return false;   /* marked row, and it is not this one */
    var vid = sw.getAttribute('data-cs-vid');
    if (!vid) return true;
    var btn = c.querySelector('.add-to-cart-btn');
    var orig = c.__csBtn ? c.__csBtn.vid : (btn ? btn.getAttribute('data-variant-id') : null);
    return !!orig && vid === orig;
  }

  /* the ring and the pressed state move to the locked swatch, within its row */
  function mark(sw){
    var row = sw.closest('.mlmt-cs');
    if (!row) return;
    [].forEach.call(row.querySelectorAll('.mlmt-cs__sw'), function(s){
      var on = s === sw;
      s.classList.toggle('is-here', on);
      if (on) s.setAttribute('aria-pressed', 'true');
      else if (s.getAttribute('aria-pressed') === 'true') s.setAttribute('aria-pressed', 'false');
    });
  }

  function lock(sw){
    var c = card(sw);
    if (!c) return;
    /* mouseover fires again for every child the pointer crosses (the <img>
       inside the swatch) — same swatch, nothing to do */
    if (c.__csLocked === sw) return;
    try {
      if (isOwn(c, sw)) restore(c); else preview(sw);
      mark(sw);
    } catch (err) {
      /* a half-applied swap is worse than none: fall back to the server's
         card rather than leave the button on a variant the picture is not */
      try { restore(c); } catch (e2) { /* nothing left to put back */ }
      return;
    }
    c.__csLocked = sw;
  }

  function swatchOf(e){
    var t = e.target;
    return t && t.closest ? t.closest('.mlmt-cs__sw') : null;
  }

  /* 18 Sep 2026 (review): a lock the SHOPPER makes — hover, focus or tap —
     takes the card out of the metal facet's hands. lockMetal() below marks
     each card it turned with __csByFacet (the swatch it put the card on);
     when her hand lands on a different swatch of that card, the mark comes
     off, so the facet's re-run on the next apply() — a Price chip toggled,
     a page appended by the infinite scroll — leaves her choice where she
     put it, and restoreAll() on Clear leaves it too. The review caught the
     other order: Silver on, hover Gold on one card to compare, toggle Price,
     and the card snapped back to silver. A hover that lands on the swatch
     the facet already chose changes nothing and keeps the mark: the card is
     still the facet's. Pressing a DIFFERENT metal chip is a fresh facet
     choice and turns every card again, hand-locked or not (lockMetal
     without the reapply flag). */
  function handLock(sw){
    lock(sw);
    var c = card(sw);
    if (c && c.__csByFacet && c.__csByFacet !== sw && c.__csLocked === sw) c.__csByFacet = null;
  }

  /* hover locks — pointer devices only; a phone's emulated mouseover is
     skipped so the tap below is the one path on touch */
  document.addEventListener('mouseover', function(e){
    if (!canHover()) return;
    var sw = swatchOf(e);
    if (sw) handLock(sw);
  });
  /* keyboard gets the same lock; tabbing away keeps it */
  document.addEventListener('focusin', function(e){
    var sw = swatchOf(e);
    if (sw) handLock(sw);
  });
  /* click / tap locks and never navigates. Modified clicks (new tab, new
     window) and non-primary buttons are left to the browser and the href. */
  document.addEventListener('click', function(e){
    var sw = swatchOf(e);
    if (!sw) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    handLock(sw);
  });

  /* ── 18 Sep 2026: the METAL FACET locks every card ─────────────────────
     Jordan: "if they select 'silver' or 'white gold' I want all variants of
     collection page to be silver as front card, for great user experience."

     The chip filter (snippets/mlmt-collection-facets) already hides the
     pieces that do not come in the chosen metal; what it could not do was
     turn the pieces that DO come in it. On a gold-default page a shopper
     who pressed Silver got a grid of gold photographs with a silver swatch
     under each — the right products, the wrong picture, and a quick-add
     still on the gold variant. So the facet now asks this controller to put
     each card on its swatch for that metal, through lock(): the same path a
     hover takes — image, title, peek price, links, quick-add variant and
     label, ring and pressed state — nothing new is written and the hover /
     click semantics are untouched.

     window.mlmtCards = { lockMetal(metal, cards?, opts?), restoreAll() }

       lockMetal(metal, cards, opts)
                                metal is 'silver' | 'gold' | 'rose-gold'
                                (white gold reads as silver — Jordan named
                                both in one breath and the catalogue photos
                                them the same). Walks the grid's cards (or
                                the list passed — the facet passes the ones
                                it left visible, so hidden cards are not
                                fetching images nobody sees), finds each
                                card's METAL swatch for it and locks it. A
                                card without one is left exactly as it is.
                                Idempotent: lock() already returns on the
                                swatch that is locked, so re-running after
                                an infinite-scroll append only touches the
                                new cards. Returns the count locked.
                                opts.reapply (review, 18 Sep 2026): true
                                when the SAME metal is being re-applied —
                                the facet passes it on every apply() after
                                the one that chose the metal — and then a
                                card the shopper has locked by hand since
                                (locked, and not carrying the facet's mark)
                                is skipped. Without it every card turns:
                                that is a fresh metal choice and wins.
       restoreAll()             puts back every card lockMetal locked — and
                                only those, by the __csByFacet mark written
                                here (the swatch the facet put the card on)
                                — by locking its own swatch again, which is
                                how a hover on the own stone restores. A
                                card the shopper locked by hand — before the
                                facet or after it (handLock takes the mark
                                off) — keeps her choice.

     WHAT A METAL SWATCH IS. snippets/mlmt-card-stones marks nothing as
     "metal" — the row is the same .mlmt-cs whether it holds stones or
     metals, and the metal swatch carries only the option value as a LABEL:
     data-cs-name="Gold" / "Silver" / "Rose Gold" (aria-label says the
     same). So the match is on that label, case-insensitively, by the
     theme's ordered tone test (rose first, white gold / silver next, gold
     LAST — "Rose Gold" and "White Gold" both contain it; the same order as
     variant-button and mlmt-variant-picker-chrome). What separates a metal
     swatch from a stone one structurally: a stone (sister) swatch is another
     product and carries data-cs-pid; the metal row is the card's own product
     and carries a variant (data-cs-vid) with no data-cs-pid; the last-resort
     single stone carries neither. No stone name in the vocabulary contains
     "gold" or "silver", but the data-cs-pid test keeps a stone row out of it
     by shape rather than by luck.

     KNOWN GAP — NOT closable from this file: a card with a colourway family
     (the six pieces with custom.group_reference — the Miami 2.0 line, the
     Classic among them) renders the sister row ONLY — six stones, no metal
     swatch at all — so on a gold page it stays gold under a Silver chip,
     with its quick-add still on the gold variant, inside a grid the filter
     calls silver (the filter keeps it because the hidden legacy
     .product-color-swatch divs say it comes in silver). Turning it needs
     snippets/mlmt-card-stones to emit the metal choice for those cards too:
     a second .mlmt-cs row with the card's OWN metal swatches — data-cs-vid
     (that metal's variant), data-cs-img (custom.silver_hero_image for
     silver, the featured image otherwise), data-cs-name (the option value),
     data-cs-price / -rawprice / -avail from that variant, NO data-cs-pid —
     which metalSwatch() below already matches with no change here. The
     hidden legacy divs carry a variant id but no image and no price, and
     the silver photograph is a metafield the browser cannot read, so a lock
     synthesised from them would put a silver button under a gold
     photograph — worse than a gold card, and deliberately not done. */
  function metalOf(v){
    v = String(v || '').toLowerCase().replace(/[-_]+/g, ' ').trim();
    if (!v) return '';
    if (v.indexOf('rose') !== -1) return 'rose-gold';
    if (v.indexOf('white gold') !== -1 || v.indexOf('silver') !== -1) return 'silver';
    if (v.indexOf('gold') !== -1) return 'gold';
    return '';
  }
  function gridCards(){
    var grid = document.getElementById('productsGrid') || document.querySelector('.products-grid');
    return grid ? grid.querySelectorAll('.product-card') : [];
  }
  /* the card's swatch for this metal: its own product (no data-cs-pid), a
     real variant (data-cs-vid non-empty), labelled with the metal */
  function metalSwatch(c, metal){
    var found = null;
    [].some.call(c.querySelectorAll('.mlmt-cs__sw[data-cs-vid]:not([data-cs-pid])'), function(sw){
      if (!sw.getAttribute('data-cs-vid')) return false;
      if (metalOf(sw.getAttribute('data-cs-name') || sw.getAttribute('aria-label')) !== metal) return false;
      found = sw;
      return true;
    });
    return found;
  }
  function lockMetal(metal, list, opts){
    var m = metalOf(metal);
    if (!m) return 0;
    var reapply = !!(opts && opts.reapply);
    var n = 0;
    [].forEach.call(list || gridCards(), function(c){
      if (!c || !c.querySelectorAll) return;
      var sw = metalSwatch(c, m);
      if (!sw) return;
      /* the same metal again (a Price chip toggled, a page appended): a
         card the shopper has locked by hand since — locked, and not
         carrying the facet's mark — is hers, not the facet's */
      if (reapply && c.__csLocked && c.__csLocked !== sw && !c.__csByFacet) return;
      lock(sw);
      /* lock() sets __csLocked only when the swap went through (its catch
         restores and leaves it), so a card is marked only if it really
         moved — restoreAll() then has nothing half-done to undo. The mark
         is the swatch itself, so handLock can tell "her hand on the
         facet's swatch" (keep) from "her hand on another" (release). */
      if (c.__csLocked === sw){ c.__csByFacet = sw; n++; }
    });
    return n;
  }
  function restoreAll(){
    var n = 0;
    [].forEach.call(document.querySelectorAll('.product-card'), function(c){
      if (!c.__csByFacet) return;
      c.__csByFacet = null;
      /* the swatch the card was rendered for — the server marks it
         (data-cs-own); for markup from before that mark, the swatch whose
         variant is the quick-add's ORIGINAL id (saved before any swap) */
      var own = c.querySelector('.mlmt-cs__sw[data-cs-own]');
      if (!own){
        var btn = c.querySelector('.add-to-cart-btn');
        var orig = c.__csBtn ? c.__csBtn.vid : (btn ? btn.getAttribute('data-variant-id') : null);
        if (orig) own = c.querySelector('.mlmt-cs__sw[data-cs-vid="' + orig + '"]');
      }
      if (own){ lock(own); }
      else { try { restore(c); } catch (e) { /* nothing left to put back */ } c.__csLocked = null; }
      n++;
    });
    return n;
  }
  window.mlmtCards = { lockMetal: lockMetal, restoreAll: restoreAll };
})();

/* ══ sections/header-group.json custom_liquid_section_KdcJ4J — the value bar under the header ══ */
/* 19 Sep 2026, Jordan: "Announcement bar static, not moving." The carousel
   controller that sat here — prev/next clicks, indicator dashes, a 4s
   setInterval auto-rotate with hover / focus / hidden-tab pauses — is
   retired, not guarded off. The bar is one line now ("Hand-set stones,
   polished 7x"), made static in assets/mlmt-chrome.css (the other two items,
   the arrows and the dots are display:none, the slide transform is pinned),
   and a static bar must not need a script at all: nothing to initialise,
   nothing for the theme editor's section re-render to leave half-bound, and
   no timer ticking for the life of every page. The markup in the section
   setting is unchanged; if the bar is ever to rotate again the CSS is where
   to start, not here. */

/* ── the card photo tap guard ─────────────────────────────────────────────────────────
   19 Sep 2026, Jordan: "back in the day if people scroll on mobile it will press the
   image and go to the product page while they were scrolling … the worst thing we can
   do is get that problem again." The card photo is a plain <a> (a.product-image-link);
   browsers already cancel a click when the finger moves during the press. This is the
   belt to that braces, for every grid on the site: the click goes through ONLY when the
   finger stayed put (≤ 10px) AND the page did not scroll (≤ 4px) between finger-down and
   the click. A scroll, a drag, a carousel swipe — none of them can open a product. Bound
   once, at the document, in the capture phase, so no card script can get in front of it. */
(function(){
  if (window.__mlmtTapGuardBound) return; window.__mlmtTapGuardBound = true;
  var down = null;
  document.addEventListener('pointerdown', function(e){
    down = { x: e.clientX, y: e.clientY, sy: window.scrollY, t: Date.now() };
  }, { capture: true, passive: true });
  document.addEventListener('touchstart', function(e){
    var t = e.touches && e.touches[0]; if (!t) return;
    down = { x: t.clientX, y: t.clientY, sy: window.scrollY, t: Date.now() };
  }, { capture: true, passive: true });
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('a.product-image-link');
    if (!a || !down) return;
    var moved = Math.hypot((e.clientX || down.x) - down.x, (e.clientY || down.y) - down.y);
    var scrolled = Math.abs(window.scrollY - down.sy);
    if (moved > 10 || scrolled > 4){
      e.preventDefault(); e.stopPropagation();
    }
  }, true);
})();
